import React from "react";
import {Link} from "react-router-dom";
import logo from '../logo.svg';

interface Props {
}

export default class HeaderAndroid extends React.Component<Props, any> {
    controllSideBar() {
        let el = document.getElementById("sidebar-0");
        if (el === null) return;
        if (el.classList.contains("collapsed")) {
            el.classList.remove("collapsed")
        } else {
            el.classList.add("collapsed")
        }
    }

    render() {
        return <>
            <div className="sticky-top top-0 show-on-android z-2 bg-white border-bottom border-3 border-secondary">
                <header className="pt-2 text-bg-light w-100">
                    <div className="d-flex flex-wrap justify-content-between px-3">
                        <Link to="" className="col-auto d-flex align-items-center mb-3 text-decoration-none text-dark">
                            <img src={logo} className="logo" alt={"логотип"}/>
                        </Link>
                        <div className="col-auto d-flex py-1">
                        <div className="col-auto">
                                <div className="dropdown d-flex justify-content-center align-middle">
                                    <p className="dropdown-toggle text-center m-0 pt-2 fs-2" id="lang"
                                       data-bs-toggle="dropdown"
                                       aria-expanded="false">
                                        <img src={`${process.env.PUBLIC_URL}/images/icons/ru_RU.png`} alt={"Ру"}/>Русский
                                    </p>
                                    <ul className="dropdown-menu p-2" aria-labelledby="lang">
                                        <li className="border-bottom border-1 p-1">
                                            <Link className="dropdown-item text-decoration-none text-dark fs-2" to="#">
                                                <img src={`${process.env.PUBLIC_URL}/images/icons/en_EN.png`} alt={"En"}/>English
                                            </Link>
                                        </li>
                                        <li className="p-1">
                                            <Link className="dropdown-item text-decoration-none text-dark fs-2" to="#">
                                                <img src={`${process.env.PUBLIC_URL}/images/icons/zh_CN.png`} alt={"中國人"}/>中國人
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <Link to="#" className="ms-2 col-auto d-flex pt-1">
                                <i className="bi bi-list fs-1 text-dark" onClick={() => this.controllSideBar()}></i>
                            </Link>
                        </div>
                    </div>
                </header>
            </div>
        </>
            ;
    }
}